import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { 
  User, 
  LogOut, 
  Home,
  ChevronDown
} from "lucide-react";
import "./TopMenu.css";

const TopMenu = ({ userData, onLogout, onProfileClick, onHomeClick }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleMenuItemClick = (action) => {
    setIsMenuOpen(false);
    if (action === 'home') {
      navigate('/dashboard');
    } else if (action === 'logout') {
      onLogout();
    }
  };

  return (
    <header className="top-menu">
      <div className="menu-content">
        <div className="welcome-text">
          <h1>أهلاً وسهلاً، {userData.name || "ضيف"}</h1>
        </div>

        <div className="menu-actions">
          <div className="user-menu">
            <button 
              className="user-button"
              onClick={handleMenuToggle}
              aria-expanded={isMenuOpen}
            >
              {userData.avatar ? (
                <img
                  src={`https://pub-de9dc6e47f7c429ca4b7cd5f036cdacb.r2.dev/${userData.avatar}`}
                  alt={userData.name || "User avatar"}
                  className="user-avatar"
                />
              ) : (
                <User size={24} />
              )}
              <ChevronDown size={16} className={`menu-arrow ${isMenuOpen ? 'open' : ''}`} />
            </button>

            {isMenuOpen && (
              <div className="menu-dropdown">
                <button 
                  className="menu-item"
                  onClick={() => handleMenuItemClick('home')}
                >
                  <Home size={18} />
                  <span>الرئيسية</span>
                </button>
                <button 
                  className="menu-item"
                  onClick={() => handleMenuItemClick('logout')}
                >
                  <LogOut size={18} />
                  <span>تسجيل الخروج</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default TopMenu;
